export const EVENT_INTERACTION = 'EventInteraction';
export enum EventInteractions {
    Impression = 'impression',
    Mounted = 'mounted',
    Click = 'click',
    Hover = 'hover',
}
export const HEAP_EVENT_CARD_CLICK = 'EventCardClick';
export const HEAP_EVENT_CARD_IMPRESSION = 'EventCardImpression';
